import Api from '../config/api';
import { ITwilioPhoneResponse, ITwilioCheckResult } from '../models/TwilioPhones/TwilioPhone';

export interface IAxiosTwilioPhones {
  data: ITwilioPhoneResponse;
}

export class TwilioPhoneActions {
  static getPhones(filterString: string): Promise<IAxiosTwilioPhones> {
    return Api.get('/twilio-phones?' + filterString);
  }

  static getDepartments(): Promise<{ data: Array<{ id: number; name: string }> }> {
    return Api.get('/departments');
  }

  static checkPhone(id: number): Promise<{ data: ITwilioCheckResult }> {
    return Api.get('/twilio-phones/' + id + '/check');
  }
}
